// extracted by mini-css-extract-plugin
export default {"mainBetslip":"styles_mainBetslip__g+K8F"};